import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/TopNavbar";
import GoogleApplicationForm from "../Components/ApplyNow/GoogleFormApplication";
// import ApplicationForm from "../components/ApplyNow/ApplicationForm";
import FAQs from "../Components/Landingpage/Faqs";
import Testimonials from "../Components/Landingpage/Testimonials";
import Footer from "../Components/Footer";

const Apply = () => {
  return (
    <>
      <Helmet>
        <title>Apply Now | Innkeeper</title>
        <meta name="description" content="Apply for a course at Innkeeper" />
      </Helmet>
      <Navbar />
      <GoogleApplicationForm />
      <FAQs />
      <Testimonials />
      <Footer />
    </>
  );
};

export default Apply;
